import Enum from "../../../../../../enums/Enum";

const ReportStatusEnum = new Enum({
    REPORT_PRESENT: {name: "Report present"},
    REPORT_SCANNED: {name: "Report scanned"},
    OTHER: {name: "Other"}
});

export default ReportStatusEnum;